export function featuresGridSliderMobile() {
    const $window = $(window);
    const $slider = $(".features-grid.slider-on-mobile");
    let sliderNav;
    console.log($slider);
    $window.on("load resize", function () {
        $slider.each(function (i, it) {
            let $this = $(this);

            if ($(it).siblings(".slider-nav").length > 0) {
                sliderNav = $(it).siblings(".slider-nav");
            }

            if ($window.innerWidth() >= 1024) {
                if ($this.hasClass("slick-initialized")) {
                    $this.slick("refresh");
                    $this.slick("unslick");
                }
            } else {
                if (!$this.hasClass("slick-initialized")) {
                    $this.slick({
                        slidesToScroll: 1,
                        slidesToShow: 1.05,
                        infinite: false,
                        dots: true,
                        mobileFirst: true,
                        adaptiveHeight: true,
                        nextArrow: "<button class=\"slide-arrow slick-next\" aria-label=\"button-next\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\"><path d=\"M11.667 19.8332L17.5003 13.9998L11.667 8.1665\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></button>",
                        prevArrow: "<button class=\"slide-arrow slick-prev\" aria-label=\"button-prev\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\" style=\"transform: scaleX(-1);\"><path d=\"M11.667 19.8332L17.5003 13.9998L11.667 8.1665\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></button>",
                        appendDots: sliderNav,
                        appendArrows: sliderNav,
                    });
                }
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/featuresGridSliderMobile.js